import { Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RefreshersService {
  clientsO = new BehaviorSubject<any>(null);
  ticketsO = new BehaviorSubject<any>(null);

  clientsS = toSignal(this.clientsO);
  ticketsS = toSignal(this.ticketsO);
}
